var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgKitchen = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M1.5 15.188h15M6.375 2.813h5.25M9 2.813v2.25m-4.687 7.5v2.624M15.938 12A6.936 6.936 0 0 0 9 5.063 6.936 6.936 0 0 0 2.063 12v.563h13.875zm-2.269.563v2.624" }) }))); };
export default SvgKitchen;
